import { useLocation } from "@tanstack/react-router";
import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { SftpNavTabs } from "@/features/admin/components/SftpNavTabs";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/sftp")({
    component: SftpLayout,
});

function SftpLayout() {
    const pathname = useLocation({ select: (location) => location.pathname });
    const isPreviewPage = pathname.endsWith("/developer/sftp/preview");

    return (
        <AdminPageLayout
            title={isPreviewPage ? "Report preview" : "SFTP report delivery"}
            description={
                isPreviewPage
                    ? "Review the uploaded diary PDF and NHS sidecar metadata together."
                    : "Track diary PDF uploads to NHS SFTP folders, review progress by organisation, and trigger manual renders."
            }
        >
            <div className="space-y-6">
                {!isPreviewPage && <SftpNavTabs />}
                <Outlet />
            </div>
        </AdminPageLayout>
    );
}
